import { render, staticRenderFns } from "./UserBills.vue?vue&type=template&id=8a2cdd46"
import script from "./UserBills.js?vue&type=script&lang=js&external"
export * from "./UserBills.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports